// Lead Trends Chart Component
// Area chart showing daily leads, viable leads, and conversions over time

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';
import { 
  AreaChart, 
  Area, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer 
} from 'recharts';
import { COLORS } from './analyticsConstants';

const TrendsChart = ({ trends }) => {
  if (!trends) return null;

  return (
    <Card className="border-slate-200" data-testid="trends-chart">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-teal-500" />
          Lead Trends
        </CardTitle>
        <CardDescription>Daily leads, viable leads, and conversions over time</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%" minWidth={200} minHeight={200}>
            <AreaChart data={trends.trends}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis 
                dataKey="date" 
                tick={{ fontSize: 12 }}
                tickFormatter={(value) => {
                  const date = new Date(value);
                  return `${date.getMonth()+1}/${date.getDate()}`;
                }}
              />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip 
                labelFormatter={(value) => new Date(value).toLocaleDateString()}
              />
              <Legend />
              <Area 
                type="monotone" 
                dataKey="leads" 
                stackId="1"
                stroke={COLORS.primary} 
                fill={COLORS.primary}
                fillOpacity={0.3}
                name="Total Leads"
              />
              <Area 
                type="monotone" 
                dataKey="viable" 
                stackId="2"
                stroke={COLORS.info} 
                fill={COLORS.info}
                fillOpacity={0.3}
                name="Viable Leads"
              />
              <Area 
                type="monotone" 
                dataKey="converted" 
                stackId="3"
                stroke={COLORS.success} 
                fill={COLORS.success}
                fillOpacity={0.3}
                name="Converted"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default TrendsChart;
